/* ============================================================
   THG PLP AJAX SWATCHES + QUICK ADD
   ============================================================
   Ported from Three Nails collection-swatches.js / quick-add-sizes.js,
   adapted to THG card DOM.

   1. Color swatch click on product cards: no navigation — fetch
      /products/{handle}.js, preload + swap primary and hover image,
      update title/links, size links, and quick-add buttons.
   2. Quick add: size buttons are server-rendered <quick-add-button
      variant-id> elements (theme handles ATC + drawer). JS only
      re-renders them on color change and runs the mobile popup.
   ============================================================ */
(function () {
  'use strict';

  if (window.__thgCardAjaxInit) return;
  window.__thgCardAjaxInit = true;

  var cache = Object.create(null);

  /* ---------- card lookups ---------- */

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function card(el) { return el.closest('.product-card'); }
  function leadImg(c) { return c.querySelector('img.product-card__image'); }
  function hoverImg(c) {
    var w = c.querySelector('.product-card__second-image');
    return w ? w.querySelector('img') : null;
  }
  function mediaLink(c) {
    var m = c.querySelector('.media');
    return m ? m.closest('a') : null;
  }
  function titleLink(c) { return c.querySelector('.product-name a'); }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* Mirror of the theme's replace chain in product-variant-option-radio.liquid */
  var YOUTH_MAP = [
    ['Youth Extra Small', 'YXS'], ['Youth Extra Large', 'YXL'], ['Youth 2XL', 'Y2XL'],
    ['Youth Small', 'YS'], ['Youth Large', 'YL'], ['Youth Medium', 'YM'],
    ['Youth XS', 'YXS'], ['Youth XL', 'YXL'],
    ['Youth S', 'YS'], ['Youth L', 'YL'], ['Youth M', 'YM']
  ];

  function normalizeSize(str) {
    if (!str) return str;
    var out = String(str);
    YOUTH_MAP.forEach(function (pair) {
      out = out.replace(new RegExp(pair[0], 'gi'), pair[1]);
    });
    return out
      .replace(/XXXXL/gi, '4XL')
      .replace(/XXXL/gi, '3XL')
      .replace(/XXL/gi, '2XL')
      .replace(/XXXS/gi, '3XS')
      .replace(/XXS/gi, '2XS');
  }

  /* ---------- product fetch / image preload ---------- */

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) cache[handle] = j; return j; });
  }

  var SRCSET_WIDTHS = [360, 450, 540, 630, 720, 900, 1050, 1200];
  var FALLBACK_WIDTH = 720;

  function cdnUrl(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildSrcset(src) {
    return SRCSET_WIDTHS.map(function (w) {
      return cdnUrl(src, w) + ' ' + w + 'w';
    }).join(', ');
  }

  /* Preload the exact candidate the browser will pick for this <img>
     (same srcset + sizes), so the swap paints from cache. */
  function preloadFor(el, src) {
    if (!el || !src) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    var sizes = el.getAttribute('sizes');
    if (sizes) img.sizes = sizes;
    img.srcset = buildSrcset(src);
    img.src = cdnUrl(src, FALLBACK_WIDTH);
    if (img.decode) return img.decode().catch(function () {});
    return new Promise(function (resolve) { img.onload = img.onerror = resolve; });
  }

  function setImg(el, src, alt) {
    if (!el || !src) return;
    el.srcset = buildSrcset(src);
    el.src = cdnUrl(src, FALLBACK_WIDTH);
    if (alt) el.alt = alt;
  }

  /* Warm JSON + both images for a swatch's colorway (hover/touch). */
  function warm(c, handle) {
    fetchProduct(handle).then(function (j) {
      if (!j) return;
      var imgs = j.images || [];
      preloadFor(leadImg(c), imgs[0]);
      preloadFor(hoverImg(c), imgs[1] || imgs[0]);
    }).catch(function () {});
  }

  /* ---------- swatch selection state ---------- */

  function selectInTrack(target) {
    var wrap = target.closest('[data-card-swatches-wrap]');
    if (!wrap) return;
    wrap.querySelectorAll('.color-swatch').forEach(function (n) {
      n.classList.remove('is-selected');
    });
    target.classList.add('is-selected');
  }

  /* ---------- size links row (data-size-link → PDP) ---------- */

  function updateSizeLinks(c, j) {
    var links = c.querySelectorAll('.product-card-sizes a[data-size-link]');
    if (!links.length) return;
    var map = Object.create(null);
    (j.variants || []).forEach(function (v) {
      var key = normalizeSize(v.option1 || v.title).toUpperCase().trim();
      map[key] = v;
    });
    links.forEach(function (a) {
      var key = normalizeSize(a.textContent).toUpperCase().trim();
      var v = map[key];
      if (v) {
        a.href = root() + 'products/' + j.handle + '?variant=' + v.id;
        a.classList.toggle('unavailable', !v.available);
      } else {
        a.classList.add('unavailable');
      }
    });
  }

  /* ---------- quick add buttons re-render ---------- */

  function quickAddButtonsHtml(j) {
    if (!j || !j.available) {
      return '<span class="quick-add-sizes__empty">Unavailable</span>';
    }
    var variants = j.variants || [];
    if (variants.length === 1 && variants[0].title === 'Default Title') {
      return '<quick-add-button variant-id="' + variants[0].id + '">' +
        '<button type="button" class="quick-add-sizes__btn">Add</button></quick-add-button>';
    }
    if (j.options && j.options.length > 1) return ''; // multi-option products: no card quick add
    return variants.map(function (v) {
      var label = esc(normalizeSize(v.title));
      if (!v.available) {
        return '<button type="button" class="quick-add-sizes__btn quick-add-sizes__btn--sold-out" disabled>' + label + '</button>';
      }
      return '<quick-add-button variant-id="' + v.id + '">' +
        '<button type="button" class="quick-add-sizes__btn">' + label + '</button></quick-add-button>';
    }).join('');
  }

  function renderQuickAdd(c, j) {
    var html = quickAddButtonsHtml(j);
    ['[data-quick-add-buttons]', '[data-quick-add-mobile-buttons]'].forEach(function (sel) {
      var el = c.querySelector(sel);
      if (el) el.innerHTML = html;
    });
    var wrap = c.querySelector('[data-quick-add-sizes]');
    if (wrap) wrap.dataset.productHandle = j.handle;
  }

  /* ---------- swatch click: swap card to sibling colorway ---------- */

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-card-swatches-wrap] a.color-swatch');
    if (!a) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var c = card(a);
    if (!c) return;

    var href = a.getAttribute('href');
    var handle = handleFromHref(href);
    if (!handle) return;

    if (c.dataset.activeHandle === handle) {
      selectInTrack(a);
      return;
    }

    selectInTrack(a);

    if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch (_) {}
    c.__swatchCtrl = new AbortController();
    c.__swatchToken = (c.__swatchToken || 0) + 1;
    var token = c.__swatchToken;

    fetchProduct(handle).then(function (j) {
      if (!j) { window.location.href = href; return; }
      if (token !== c.__swatchToken) return; // stale click

      var imgs = j.images || [];
      var primary = imgs[0] || '';
      var secondary = imgs[1] || primary;

      return Promise.allSettled([preloadFor(leadImg(c), primary), preloadFor(hoverImg(c), secondary)]).then(function () {
        if (token !== c.__swatchToken) return;

        setImg(leadImg(c), primary, j.title);
        setImg(hoverImg(c), secondary, j.title);

        var mA = mediaLink(c);
        if (mA) { mA.href = href; mA.setAttribute('aria-label', j.title); }
        var tA = titleLink(c);
        if (tA) { tA.textContent = j.title; tA.href = href; }

        updateSizeLinks(c, j);
        renderQuickAdd(c, j);
        c.dataset.activeHandle = handle;
      });
    }).catch(function () { /* aborted — newer click owns the card */ });
  }, true);

  /* Keyboard: Enter/Space activates swatch without navigation */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = e.target.closest('[data-card-swatches-wrap] a.color-swatch');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    a.click();
  }, true);

  /* Prefetch product JSON + warm images on swatch hover / first touch */
  function onWarmEvent(e) {
    var a = e.target.closest('[data-card-swatches-wrap] a.color-swatch');
    if (!a) return;
    var handle = handleFromHref(a.getAttribute('href'));
    var c = card(a);
    if (handle && c) warm(c, handle);
  }
  document.addEventListener('mouseover', onWarmEvent, { passive: true });
  document.addEventListener('touchstart', onWarmEvent, { passive: true });

  /* ============================================================
     QUICK ADD — mobile popup open/close
     (ATC itself is handled by the theme's <quick-add-button>)
     ============================================================ */

  function openPopup(c) {
    var popup = c.querySelector('[data-quick-add-mobile-popup]');
    var backdrop = c.querySelector('[data-quick-add-backdrop]');
    var trigger = c.querySelector('[data-quick-add-mobile-trigger]');
    if (!popup) return;
    popup.classList.add('is-visible');
    if (backdrop) backdrop.classList.add('is-active');
    if (trigger) trigger.classList.add('is-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { popup.classList.add('is-active'); });
    });
  }

  function closePopup(c) {
    var popup = c.querySelector('[data-quick-add-mobile-popup]');
    var backdrop = c.querySelector('[data-quick-add-backdrop]');
    var trigger = c.querySelector('[data-quick-add-mobile-trigger]');
    if (!popup) return;
    popup.classList.remove('is-active');
    if (backdrop) backdrop.classList.remove('is-active');
    if (trigger) trigger.classList.remove('is-open');
    setTimeout(function () { popup.classList.remove('is-visible'); }, 200);
  }

  function closeAllPopups() {
    document.querySelectorAll('.quick-add-sizes__mobile-popup.is-visible').forEach(function (p) {
      var c = card(p);
      if (c) closePopup(c);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add-mobile-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var c = card(trigger);
      var wasOpen = trigger.classList.contains('is-open');
      closeAllPopups();
      if (c && !wasOpen) openPopup(c);
      return;
    }

    var closeBtn = e.target.closest('[data-quick-add-mobile-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var c2 = card(closeBtn);
      if (c2) closePopup(c2);
      return;
    }

    if (e.target.matches && e.target.matches('[data-quick-add-backdrop]')) {
      closeAllPopups();
    }
  });

  /* Close popup once a variant was added (theme opens the drawer) */
  document.addEventListener('variant:add', closeAllPopups);

  var scrollTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(closeAllPopups, 100);
  }, { passive: true });
})();
